import gql from 'graphql-tag';

export const InvoiceSummary = gql`
    query InvoiceSummary($siteId: SiteId, $childId: ChildId!, $updatedPlan: PlanUpdate) {
        finance {
            invoiceSummary {
                v1 {
                    overview {
                        periods(siteId: $siteId, childId: $childId, updatedPlan: $updatedPlan) {
                            kind
                            periodDateRange {
                                from
                                to
                            }
                            customDateRange {
                                from
                                to
                            }
                            billingFrequency
                            planId
                            alreadyBilled
                            isCurrentPlan
                            isLastInPlan
                            changesPricingGroup
                            payables {
                                kind
                                name
                                price {
                                    price
                                    quality
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
